module.exports = __webpack_public_path__ + "static/media/planet-moon.2e5f93e6.svg";